var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconLock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 27,
    viewBox: "0 0 23 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_73)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.7692 13.8H5.22524C4.35995 13.8 3.65656 13.0966 3.65656 12.2313V7.84345C3.65656 3.51699 7.17355 0 11.5 0C15.8265 0 19.3379 3.51699 19.3379 7.83786V12.2257C19.3379 13.091 18.6345 13.7944 17.7692 13.7944V13.8ZM6.79393 10.6626H16.2005V7.83786C16.2005 5.24199 14.0903 3.1318 11.4944 3.1318C8.89855 3.1318 6.78835 5.24199 6.78835 7.83786V10.6626H6.79393Z",
    fill: "#6D737F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 0V3.13738C14.0959 3.13738 16.2061 5.24757 16.2061 7.84345V10.6682H11.5V13.8056H17.7748C18.64 13.8056 19.3434 13.1022 19.3434 12.2369V7.84903C19.3434 3.52816 15.8265 0.011165 11.5056 0.011165L11.5 0Z",
    fill: "#5E5F69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4313 26.2379H1.56869C0.703398 26.2379 0 25.5345 0 24.6692V12.2313C0 11.366 0.703398 10.6626 1.56869 10.6626H21.4313C22.2966 10.6626 23 11.366 23 12.2313V24.6692C23 25.5345 22.2966 26.2379 21.4313 26.2379Z",
    fill: "#FFAC2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4313 10.6626H11.5V26.2379H21.4313C22.2966 26.2379 23 25.5345 23 24.6692V12.2313C23 11.366 22.2966 10.6626 21.4313 10.6626Z",
    fill: "#FF981E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1126 17.4566C14.1126 16.5913 13.4092 15.8879 12.5439 15.8879H10.4505C9.58517 15.8879 8.88177 16.5913 8.88177 17.4566C8.88177 18.1376 9.31721 18.7182 9.92571 18.9359V19.55C9.92571 20.4153 10.6291 21.1187 11.4944 21.1187C12.3597 21.1187 13.0631 20.4153 13.0631 19.55V18.9359C13.6716 18.7182 14.107 18.1432 14.107 17.4566H14.1126Z",
    fill: "#FF981E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5439 15.8879H11.5V21.1131C12.3653 21.1131 13.0687 20.4097 13.0687 19.5444V18.9304C13.6772 18.7126 14.1126 18.1376 14.1126 17.451C14.1126 16.5857 13.4092 15.8823 12.5439 15.8823V15.8879Z",
    fill: "#FF8512"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_73"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 26.2379,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLock);
export default __webpack_public_path__ + "static/media/iconLock.5eff9d20b0beeff10895d1a9607ebad5.svg";
export { ForwardRef as ReactComponent };